<div class="page-wraper">

  <!-- HEADER START -->
  <app-header1></app-header1>
  <!-- HEADER END -->


  <!-- CONTENT START -->
  <div class="page-content">

    <!-- INNER PAGE BANNER -->
    <!-- <app-page-banner title="Contact us" subtitle="Contact us"></app-page-banner> -->
    <!-- INNER PAGE BANNER END -->

    <!-- CONTACT FORM -->
    <div class="section-full bg-white nobreadcrump">
      <div class="section-content contact-section">
        <div class="container mt-4">
          <mat-tab-group dynamicHeight>

            <!-- login -->
            <mat-tab label="Patient Login">
              <div class="mat-elevation-z4">
                <div class="login-form form-style-md ">
                  <form [formGroup]="this.loginForm" (ngSubmit)="LoginSubmit()" >
                    <div class="row mb-2">
                      <div class="col-md-4">
                        <div class="logo">
                          <img src="../../../assets/images/soul-space-logo.png"  width="50%"  alt="logo">
                        </div>
                      </div>
                      <div class="col-md-6 mt-2">
                        <h5>
                          Patient Login
                        </h5>
                      </div>
                    </div>
                 
                      <div class="matt-group">
                        <mat-label>Patient Number <b class="star">*</b></mat-label>
                      <mat-form-field appearance="legacy">
                        <input matInput placeholder="" formControlName="patient_number" [attr.autocomplete]="'off'">
                        <mat-error *ngIf="Error1('patient_number','required')">Patient number is required</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="matt-group">
                      <mat-label>Password <b class="star">*</b></mat-label>
                      <mat-form-field appearance="legacy">
                        <input matInput [type]="hide ? 'password' : 'text'"  placeholder="" formControlName="password" [attr.autocomplete]="'off'">
                        
                        <!-- <mat-icon (click)="togglePasswordVisibility($event)" [attr.aria-label]="hide ? 'Show password' : 'Hide password'" [attr.aria-pressed]="!hide" style="margin-left: -20px; cursor: pointer;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon> -->
                       
                        <mat-error *ngIf="Error1('password', 'required')">Password is required</mat-error>
                      </mat-form-field>
                      </div>
                    <div class="mt-2">
                      <button type="submit" [disabled]="signinDisable" mat-raised-button style="background-color: #6b7c52; color: white;"  class="w-100" >{{ loginButton }}</button>
                    </div>
                  </form>
                  </div>
              </div>
            </mat-tab>

              <!-- Registration -->

            <mat-tab label="New Registration" class="tabcustome">
              <div class="example-large-box mat-elevation-z4">
                <form [formGroup]="RegisterForm" autocomplete="off" (ngSubmit)="onSubmit()">
                  <div class="wizard-content form-style-md p-0 mt-4">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Salutation<b class="star">*</b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select placeholder="Select Salutation" formControlName="title">
                              <mat-option value="">----- Select Salutation -----</mat-option>
                              <ng-container *ngFor="let look of Salutation">

                                <mat-option *ngIf="look.type.code=='TIT'" [value]="look.id">{{look.name}}</mat-option>
                              </ng-container>
                            </mat-select>
                            <mat-error *ngIf="Error('title','required')">Select The Salutation</mat-error>
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Full Name<b class="star">*</b></mat-label>
                          <mat-form-field appearance="fill">
                            <input matInput placeholder="Name" formControlName="fullname" maxlength="100"
                              (input)="onNameInput($event)">
                            <mat-error *ngIf="Error('fullname', 'required')">Please Enter Full Name</mat-error>
                            <mat-error *ngIf="Error('fullname', 'pattern')">Only Characters (A-Z, a-z) are allowed in
                              this field</mat-error>
                          </mat-form-field>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <div class="matt-group matt-date-pickers">
                          <mat-label>DOB <b class="star">*</b></mat-label>
                          <mat-form-field appearance="fill">
                            <input matInput formControlName="DOB" [matDatepicker]="dob" [max]="date"
                              onclick="$('#dob').trigger('click'); return false;" placeholder="DD/MM/YYYY"
                              autocomplete="off" (keydown)="disableDate()" (change)="Agestatus()">
                            <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                            <mat-datepicker #dob></mat-datepicker>
                            <mat-error *ngIf="Error('DOB','required')">DOB is required</mat-error>
                          </mat-form-field>

                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Gender</mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select placeholder="Gender" formControlName="gender"
                              (selectionChange)="onGenderChange($event)">
                              <mat-option value="">----- Select Gender -----</mat-option>
                              <ng-container *ngFor="let look of Gender">
                                <mat-option *ngIf="look.type.code == 'GENDER'"
                                  [value]="look.id">{{look.name}}</mat-option>
                              </ng-container>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Age</mat-label>
                          <mat-form-field appearance="fill">
                            <!-- <input matInput formControlName="age" placeholder="Age" maxlength="100"> -->
                            <input matInput formControlName="Age" [value]="RegisterForm.get('DOB').value ? (RegisterForm.get('DOB').value | age) : ''"
                              placeholder="Age" [readonly]="hideDOB">
                          </mat-form-field>
                          <!-- <mat-error *ngIf="Error('Age','required')">Enter The Age</mat-error> -->
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Marital Status<b class="star"></b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select placeholder="Select Marital Status" formControlName="MaritalStatus">
                              <mat-option value="">----- Select Marital Status -----</mat-option>
                              <ng-container *ngFor="let look of MaritalStatus">

                                <mat-option *ngIf="look.type.code=='MS'" [value]="look.id">{{look.name}}</mat-option>
                              </ng-container>
                            </mat-select>
                            <mat-error *ngIf="Error('MaritalStatus','required')">Select The Marital Status</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <!-- <div class="col-md-4" ></div> -->
                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>E-Mail<b class="star">*</b></mat-label>
                          <mat-form-field appearance="fill">
                            <input matInput formControlName="email" placeholder="@examble.com">
                          </mat-form-field>
                          <mat-error *ngIf="Error('email','required')">Enter The Email</mat-error>
                        </div>
                      </div>

                      <div class="col-md-8">
                        <div class="matt-group">
                          <mat-label>Address</mat-label>
                          <mat-form-field appearance="fill">
                            <textarea matInput formControlName="Address" placeholder="Address"></textarea>
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Country<b class="star">*</b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select formControlName="Country" placeholder="Select Country">
                              <mat-option>----- Select Country -----</mat-option>
                              <mat-option *ngFor="let country of countries"
                                [value]="country.id">{{country.name}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="Error('Country','required')">Select The Country</mat-error>

                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Nationality<b class="star">*</b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select formControlName="nationality" placeholder="Select Nationality">
                              <mat-option>----- Select Nationality -----</mat-option>
                              <mat-option *ngFor="let look of nationality" [value]="look.id">{{look.name}}</mat-option>
                            </mat-select>

                            <mat-error *ngIf="Error('nationality','required')">Select The Nationality</mat-error>
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>State<b class="star">*</b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select formControlName="State" placeholder="Select State">
                              <mat-option>----- Select State -----</mat-option>
                              <mat-option *ngFor="let state of state" [value]="state.id">{{state.name}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="Error('State','required')">Select The State</mat-error>

                          </mat-form-field>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>City<b class="star">*</b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select formControlName="City" placeholder="Select City">
                              <mat-option>----- Select City -----</mat-option>
                              <mat-option *ngFor="let city of cities" [value]="city.id">{{city.name}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="Error('City','required')">Select The City</mat-error>

                          </mat-form-field>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Center<b class="star">*</b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select formControlName="center" placeholder="Select Center">
                              <mat-option>----- Select Center -----</mat-option>
                              <mat-option *ngFor="let center of Center" [value]="center.id">{{center.name}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="Error('center','required')">Select The Center</mat-error>

                          </mat-form-field>
                        </div>
                      </div>



                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Pin Code</mat-label>
                          <mat-form-field appearance="fill">
                            <input matInput formControlName="PinCode" placeholder="Pin Code" maxlength="6" type="text"
                              (input)="onInput($event)">

                            <!-- Validation Errors -->
                            <mat-error *ngIf="RegisterForm.get('PinCode').hasError('required')">
                              Pin Code is required.
                            </mat-error>
                            <mat-error *ngIf="RegisterForm.get('PinCode').hasError('pattern')">
                              Only numbers are allowed, and it must be exactly 6 digits.
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group flag-select">
                          <mat-label>Mobile Number <b class="star">*</b></mat-label>

                          <mat-form-field appearance="fill">
                            <input matInput formControlName="mobile" type="number" placeholder="Mobile Number"
                              name="office_phone" maxlength="15" inputmode="numeric">
                            <mat-error *ngIf="phoneControl.touched && phoneControl.invalid">
                              Enter a valid mobile number
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>


                      <div class="col-md-4" *ngIf="ClientHidden">
                        <div class="matt-group">
                          <mat-label>Client<b class="star">*</b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select formControlName="CliName" placeholder="Select Client" [readonly]="showClient">
                              <mat-option>----- Select Client -----</mat-option>
                              <mat-option *ngFor="let Client of ClientsList" [value]="Client.id">{{Client.client_name}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="Error('CliName','required')">Select The Client</mat-error>

                          </mat-form-field>
                        </div>
                      </div>



                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Visit Type<b class="star"></b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select panelClass="custom-dropdown-panel" placeholder="Select Visit Type"
                              formControlName="referral_type" (selectionChange)="onReferalType($event)">
                              <mat-option value="">----- Select Visit Type -----</mat-option>
                              <ng-container *ngFor="let look of VisitType">

                                <mat-option *ngIf="look.type.code=='REFRAL'"
                                  [value]="look.id">{{look.name}}</mat-option>
                              </ng-container>
                            </mat-select>
                            <!-- <mat-error *ngIf="Error('MaritalStatus','required')">Select The Marital Status</mat-error> -->
                          </mat-form-field>
                        </div>
                      </div>
                      <div *ngIf="refrel_person === 508" class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Referral Person<b class="star"></b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select panelClass="custom-dropdown-panel" placeholder="Select Referral Person"
                              formControlName="referral_person">
                              <mat-option value="">----- Select Referral Person -----</mat-option>
                              <ng-container *ngFor="let look of ReferralPerson">
                                <mat-option *ngIf="look.type.code=='REFPSON'"
                                  [value]="look.id">{{look.name}}</mat-option>
                              </ng-container>
                            </mat-select>
                            <!-- <mat-error *ngIf="Error('MaritalStatus','required')">Select The Marital Status</mat-error> -->
                          </mat-form-field>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Education Level<b class="star"></b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select panelClass="custom-dropdown-panel" placeholder="Select  Education Level"
                              formControlName="education_level" (selectionChange)="onGenderChange2($event)">
                              <mat-option value="">----- Select Education Level -----</mat-option>
                              <ng-container *ngFor="let look of EducationLevel">

                                <mat-option *ngIf="look.type.code=='EDULEV'"
                                  [value]="look.id">{{look.name}}</mat-option>
                              </ng-container>
                            </mat-select>
                            <!-- <mat-error *ngIf="Error('MaritalStatus','required')">Select The Marital Status</mat-error> -->
                          </mat-form-field>
                        </div>
                      </div>

                      <div *ngIf="selectedGender2 === 490" class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Other (Education)</mat-label>
                          <mat-form-field appearance="fill">
                            <input matInput placeholder="Enter Other (Education)" formControlName="education_orthers"
                              maxlength="100">
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Occupation<b class="star"></b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select panelClass="custom-dropdown-panel" placeholder="Select  Occupation"
                              formControlName="occupation" (selectionChange)="onGenderChange1($event)">
                              <mat-option value="">----- Select Occupation -----</mat-option>
                              <ng-container *ngFor="let look of Occupation">

                                <mat-option *ngIf="look.type.code=='OCCUPN'"
                                  [value]="look.id">{{look.name}}</mat-option>
                              </ng-container>
                            </mat-select>
                            <!-- <mat-error *ngIf="Error('MaritalStatus','required')">Select The Marital Status</mat-error> -->
                          </mat-form-field>
                        </div>
                      </div>


                      <div *ngIf="selectedGender1 === 495" class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Other (Occupation)</mat-label>
                          <mat-form-field appearance="fill">
                            <input matInput placeholder="Enter Other Occupation" formControlName="occupation_orthers"
                              maxlength="100">
                          </mat-form-field>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Emergency Relationship<b class="star"></b></mat-label>
                          <mat-form-field appearance="fill">
                            <mat-select panelClass="custom-dropdown-panel" placeholder="Select  Emergency Relationship"
                              formControlName="emg_contact_relationship"
                              (selectionChange)="onRelationshipChange($event)">
                              <mat-option value="">----- Select Emergency Relationship -----</mat-option>
                              <ng-container *ngFor="let look of EmergencyRelationship">

                                <mat-option *ngIf="look.type.code=='EMEREL'"
                                  [value]="look.id">{{look.name}}</mat-option>
                              </ng-container>
                            </mat-select>
                            <!-- <mat-error *ngIf="Error('MaritalStatus','required')">Select The Marital Status</mat-error> -->
                          </mat-form-field>
                        </div>
                      </div>
                      <div *ngIf="selectedRelationship === 499" class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Other (Emergency Relationship)</mat-label>
                          <mat-form-field appearance="fill">
                            <input matInput placeholder="Enter Other Emergency Relationship"
                              formControlName="relationship_orthers" maxlength="100">
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group">
                          <mat-label>Emergency Contact Name</mat-label>
                          <mat-form-field appearance="fill">
                            <input matInput placeholder="Emergency Contact Name" formControlName="emg_contact_name"
                              maxlength="100">
                            <!-- <mat-error *ngIf="Error('first_name', 'required')">Please Enter First Name</mat-error>
                  <mat-error *ngIf="Error('first_name', 'pattern')">Only Characters (A-Z, a-z) are allowed in this field</mat-error> -->
                          </mat-form-field>

                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="matt-group flag-select">
                          <mat-label>Emergency Contact Number</mat-label>

                          <mat-form-field appearance="fill">
                            <input matInput formControlName="emg_contact_number" type="number"
                              placeholder="Emergency Contact Number"  name="office_phone"
                              maxlength="15" inputmode="numeric">
                            <mat-error *ngIf="phoneControl.touched && phoneControl.invalid">
                              Enter a valid Emergency Contact Number
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>


                    </div>
                    <div class="button-group-lg mt-2">
                      <button class="btn btn-outline-primary btn-lg float-right" type="submit" >Save</button>
                    </div>
                  </div>
                </form>
              </div>
            </mat-tab>
          </mat-tab-group>

        </div>




      </div>
    </div>

  </div>
  <!-- CONTENT END -->

  <app-footer1></app-footer1>

</div>

<app-loader></app-loader>